import { render } from "./DynamicPropertyFields.vue?vue&type=template&id=5de4b6be&scoped=true"
import script from "./DynamicPropertyFields.vue?vue&type=script&lang=js"
export * from "./DynamicPropertyFields.vue?vue&type=script&lang=js"

import "./DynamicPropertyFields.vue?vue&type=style&index=0&id=5de4b6be&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5de4b6be"

export default script